var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZebraLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "108px",
    height: "37px",
    viewBox: "0 0 108 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.960784,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.324219 1.355469 C 16.453125 1.433594 17.769531 2.523438 18.261719 4.625 C 18.496094 6.847656 17.585938 8.359375 15.527344 9.15625 C 16.300781 9.1875 17.074219 9.21875 17.84375 9.25 C 18.636719 10.03125 19.40625 10.824219 20.164062 11.632812 C 19.082031 11.710938 18 11.757812 16.917969 11.773438 C 17.660156 12.519531 18.402344 13.269531 19.144531 14.015625 C 20.316406 14.046875 21.492188 14.078125 22.667969 14.109375 C 23.457031 14.886719 24.226562 15.683594 24.984375 16.492188 C 23.902344 16.570312 22.820312 16.617188 21.738281 16.632812 C 22.464844 17.363281 23.191406 18.09375 23.917969 18.828125 C 23.964844 20.320312 23.980469 21.816406 23.964844 23.3125 C 24.738281 23.3125 25.507812 23.3125 26.28125 23.3125 C 26.28125 22.285156 26.28125 21.257812 26.28125 20.230469 C 27.117188 20.214844 27.949219 20.230469 28.785156 20.273438 C 29.789062 21.289062 30.792969 22.300781 31.796875 23.3125 C 31.832031 24.851562 31.195312 26.019531 29.898438 26.816406 C 27.910156 27.773438 26.164062 27.445312 24.660156 25.835938 C 24.128906 25.113281 23.863281 24.304688 23.871094 23.40625 C 23.066406 23.40625 22.265625 23.40625 21.460938 23.40625 C 21.476562 21.101562 21.460938 18.796875 21.414062 16.492188 C 20.671875 15.742188 19.929688 14.996094 19.191406 14.25 C 19.144531 17.300781 19.128906 20.351562 19.144531 23.40625 C 18.308594 23.40625 17.476562 23.40625 16.640625 23.40625 C 16.640625 19.511719 16.640625 15.617188 16.640625 11.726562 C 15.898438 11.726562 15.15625 11.726562 14.414062 11.726562 C 14.398438 15.464844 14.414062 19.199219 14.460938 22.9375 C 15.203125 23.6875 15.945312 24.433594 16.6875 25.179688 C 16.75 26.394531 16.75 27.609375 16.6875 28.824219 C 15.109375 27.234375 13.535156 25.648438 11.957031 24.058594 C 11.929688 19.480469 11.898438 14.902344 11.867188 10.324219 C 9.792969 8.253906 7.738281 6.164062 5.703125 4.0625 C 6.03125 3.71875 6.402344 3.421875 6.8125 3.175781 C 7.128906 2.941406 7.46875 2.785156 7.832031 2.710938 C 10.007812 4.808594 12.15625 6.941406 14.277344 9.109375 C 14.324219 6.523438 14.339844 3.941406 14.324219 1.355469 Z M 14.324219 1.355469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.952941,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 3.941406 5.746094 C 5.875 7.464844 7.746094 9.269531 9.546875 11.164062 C 9.609375 14.683594 9.609375 18.203125 9.546875 21.722656 C 6.796875 18.980469 4.078125 16.207031 1.390625 13.40625 C 1.296875 12.363281 1.386719 11.335938 1.667969 10.324219 C 1.707031 10.28125 1.753906 10.25 1.808594 10.230469 C 3.566406 11.957031 5.3125 13.703125 7.046875 15.464844 C 7.105469 14.40625 7.105469 13.34375 7.046875 12.285156 C 5.5625 10.804688 4.09375 9.3125 2.640625 7.800781 C 3.03125 7.082031 3.460938 6.398438 3.941406 5.746094 Z M 3.941406 5.746094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.976471,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 37.777344 9.296875 C 41.546875 9.28125 45.316406 9.296875 49.085938 9.34375 C 46.675781 13.984375 44.265625 18.625 41.855469 23.265625 C 43.988281 23.28125 46.121094 23.328125 48.253906 23.40625 C 47.664062 24.527344 47.078125 25.648438 46.492188 26.769531 C 42.722656 26.894531 38.949219 26.894531 35.179688 26.769531 C 37.558594 22.160156 39.941406 17.550781 42.320312 12.941406 C 40.21875 12.847656 38.117188 12.816406 36.015625 12.847656 C 36.550781 11.640625 37.140625 10.457031 37.777344 9.296875 Z M 37.777344 9.296875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.972549,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 50.382812 9.296875 C 53.753906 9.296875 57.121094 9.296875 60.488281 9.296875 C 60.488281 10.480469 60.488281 11.664062 60.488281 12.847656 C 58.574219 12.847656 56.65625 12.847656 54.742188 12.847656 C 54.742188 14 54.742188 15.152344 54.742188 16.304688 C 56.65625 16.304688 58.574219 16.304688 60.488281 16.304688 C 60.488281 17.488281 60.488281 18.671875 60.488281 19.855469 C 58.574219 19.855469 56.65625 19.855469 54.742188 19.855469 C 54.742188 21.007812 54.742188 22.160156 54.742188 23.3125 C 56.65625 23.3125 58.574219 23.3125 60.488281 23.3125 C 60.488281 24.496094 60.488281 25.679688 60.488281 26.863281 C 57.121094 26.863281 53.753906 26.863281 50.382812 26.863281 C 50.382812 21.007812 50.382812 15.152344 50.382812 9.296875 Z M 50.382812 9.296875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.984314,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 62.4375 9.296875 C 65.25 9.257812 68.0625 9.304688 70.871094 9.4375 C 73.472656 9.878906 74.800781 11.433594 74.859375 14.109375 C 74.796875 16.074219 73.871094 17.414062 72.078125 18.125 C 74.113281 18.699219 75.101562 20.054688 75.042969 22.191406 C 75.050781 24.910156 73.722656 26.449219 71.058594 26.816406 C 68.183594 26.863281 65.308594 26.878906 62.4375 26.863281 C 62.4375 21.007812 62.4375 15.152344 62.4375 9.296875 Z M 66.699219 12.566406 C 67.683594 12.492188 68.640625 12.601562 69.574219 12.894531 C 70.15625 13.273438 70.433594 13.820312 70.410156 14.527344 C 70.398438 15.644531 69.84375 16.285156 68.738281 16.445312 C 68.0625 16.492188 67.382812 16.507812 66.699219 16.492188 C 66.699219 15.183594 66.699219 13.875 66.699219 12.566406 Z M 66.699219 19.761719 C 67.636719 19.722656 68.5625 19.769531 69.480469 19.902344 C 70.324219 20.230469 70.726562 20.851562 70.6875 21.769531 C 70.628906 23.125 69.917969 23.78125 68.554688 23.730469 C 67.9375 23.777344 67.320312 23.792969 66.699219 23.777344 C 66.699219 22.441406 66.699219 21.101562 66.699219 19.761719 Z M 66.699219 19.761719 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.980392,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 76.621094 9.296875 C 79.25 9.257812 81.875 9.304688 84.5 9.4375 C 87.71875 9.925781 89.324219 11.808594 89.320312 15.089844 C 89.382812 17.605469 88.304688 19.414062 86.074219 20.507812 C 87.277344 22.578125 88.5 24.632812 89.738281 26.675781 C 91.609375 20.90625 93.511719 15.144531 95.4375 9.390625 C 97.261719 9.265625 99.085938 9.265625 100.90625 9.390625 C 102.847656 15.199219 104.734375 21.023438 106.5625 26.863281 C 105.015625 26.894531 103.472656 26.863281 101.929688 26.769531 C 101.550781 25.65625 101.210938 24.535156 100.90625 23.40625 C 99.054688 23.390625 97.199219 23.40625 95.347656 23.453125 C 94.976562 24.574219 94.605469 25.695312 94.234375 26.816406 C 91.019531 26.894531 87.804688 26.878906 84.59375 26.769531 C 83.382812 24.664062 82.195312 22.546875 81.023438 20.414062 C 80.976562 22.5625 80.960938 24.714844 80.976562 26.863281 C 79.523438 26.863281 78.070312 26.863281 76.621094 26.863281 C 76.621094 21.007812 76.621094 15.152344 76.621094 9.296875 Z M 80.976562 12.847656 C 81.59375 12.832031 82.214844 12.847656 82.832031 12.894531 C 84.539062 13.304688 85.207031 14.378906 84.824219 16.117188 C 84.496094 16.945312 83.894531 17.425781 83.015625 17.566406 C 82.335938 17.613281 81.65625 17.628906 80.976562 17.613281 C 80.976562 16.023438 80.976562 14.4375 80.976562 12.847656 Z M 98.035156 14.621094 C 98.664062 16.359375 99.253906 18.117188 99.796875 19.902344 C 98.683594 19.949219 97.570312 19.964844 96.457031 19.949219 C 96.96875 18.167969 97.496094 16.394531 98.035156 14.621094 Z M 98.035156 14.621094 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.945098,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 108,
    height: 37
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 1.34375 16.679688 C 6.496094 21.730469 11.609375 26.839844 16.6875 32 C 16.765625 33.1875 16.75 34.371094 16.640625 35.550781 C 11.542969 30.460938 6.460938 25.351562 1.390625 20.230469 C 1.34375 19.046875 1.328125 17.863281 1.34375 16.679688 Z M 1.34375 16.679688 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZebraLogo);
export default __webpack_public_path__ + "static/media/Zebra-logo.48ae5164302dea369fb823cdf81b0326.svg";
export { ForwardRef as ReactComponent };